module.exports = __webpack_public_path__ + "img/recharge_v3.7e8efe92.png";